import { HTMLTemplateBlockSettings } from "../../../../../../web-receipt-api/src/lib/validateReceiptStructure"
import { TemplatedOrderText } from "../../components/TemplatedOrderText"

export type HTMLTemplateBlockProps= {
  blockSettings: HTMLTemplateBlockSettings
}

export function HTMLTemplateBlock(props: HTMLTemplateBlockProps) {
  return <TemplatedOrderText template={props.blockSettings.content} />
}